import { useQuery } from '@tanstack/react-query';

import { getBusinessRatings } from '../api/endpoints/ratings';
import '../styles/reservations-summary.css';

const SHOWN = 3;

function stars(count: number): string {
  const whole = Math.max(0, Math.min(5, Math.round(count)));
  return `${'★'.repeat(whole)}${'☆'.repeat(5 - whole)}`;
}

function countWord(count: number): string {
  return count === 1 ? '1 calificación' : `${count} calificaciones`;
}

/**
 * What customers said after going (Martín, 1 Nov 2026): the average, how many,
 * and the latest words with who said them and for what. Only people who had
 * the visit can rate, so every line here is real. Silent until there is one.
 */
export function BusinessRatingsCard() {
  const query = useQuery({ queryKey: ['business-ratings'], queryFn: () => getBusinessRatings(20), retry: false, staleTime: 60_000 });
  const data = query.data;
  if (!data || data.count === 0) return null;
  const latest = data.ratings.filter((entry) => entry.comment).slice(0, SHOWN);
  return (
    <section className="section res-ratings" aria-labelledby="res-ratings-title">
      <h2 className="section-label" id="res-ratings-title">Calificaciones</h2>
      <div className="card res-ratings-card">
        <div className="res-ratings-score">
          <span className="res-ratings-average">{data.rating.toFixed(1)}</span>
          <span className="res-ratings-stars" aria-label={`${data.rating.toFixed(1)} de 5`}>{stars(data.rating)}</span>
          <span className="row-sub">{countWord(data.count)}</span>
        </div>
        {latest.length > 0 ? (
          <ul className="res-ratings-list">
            {latest.map((entry) => (
              <li key={entry.id}>
                <span className="res-ratings-stars" aria-label={`${entry.stars} de 5`}>{stars(entry.stars)}</span>
                <p className="res-ratings-words">{`“${entry.comment}”`}</p>
                <p className="row-sub">{[entry.customerName, entry.serviceName].filter(Boolean).join(' · ')}</p>
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </section>
  );
}
